import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import {getDeviceId} from './device-id-helpers';

Sentry.init({
  dsn: 'https://7b1b5437a61b4d69bedec05ff5ec0759@sentry.io/2430763',
  environment: __ENV__,
  debug: false,
  whitelistUrls: [
    /https?:\/\/(([\w]+)\.)nur\.kz/
  ],
  sampleRate: 0.1,
  integrations: [
    new Integrations.CaptureConsole({levels: ['warn', 'error']}),
    new Integrations.ExtraErrorData(),
    new Integrations.HttpClient()
  ],
  ignoreErrors: [
    // NOTE: unknown issue https://nur-team.sentry.io/issues/5128255691/events/aeeec6cbf1db4f28b0762d99cce0dfe6/
    /Failed to retrieve hasPrivateToken response. Exceeded the number-of-issuers limit/
  ],
  beforeSend: (event, hint) => {
    const isRejectedMessage = (/^(undefined|null|Failed to send JSON. See console logs)$/)
      .test(hint?.originalException?.message);

    if (isRejectedMessage) {
      return null;
    }
    return event;
  }
});

// Sentry meta tags - global_props, language and userId
const deviceId = getDeviceId();
const {targeting = {}} = window.Site;

Sentry.configureScope(scope => {
  Object.keys(targeting).forEach(key => {
    scope.setExtra(key, targeting[key]);
  });
  scope.setExtra('domain', window.Site.domain);
  scope.setTag('language', targeting.language);
  if (deviceId) {
    scope.setUser({id: deviceId});
  }
});

export const logError = error => Sentry.captureException(error);
